// Please refer to the https://ptflow.gitbook.io/ptflow-developer-docs/the-backend/api/timezones-and-utc
// All datetimes are to be interpreted as "localtime in the user's timezone"!
// This means that these seemingly UTC timestamps need to be adjusted if you actually
// intended to do any calculations on them.
// Algo:
// 1. strip the 'Z' part off the datetime
// 2. interpret the datetime as a local time in the user's set timezone (User.ISettings.timezone)
import { Events } from "app-interfaces";

// https://michalzalecki.com/nominal-typing-in-typescript/#approach-4-intersection-types-and-brands
export type Brand<K, T> = K & { __brand: T };
export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;
export type Required<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

// Removes 'optional' attributes from a type's properties
export type Concrete<Type> = {
  [Property in keyof Type]-?: Type[Property];
};
export type ConcreteKey<T, Key extends keyof T> = Omit<T, Key> & Concrete<Pick<T, Key>>;

type DashboardEvent = Events.IAgenda;
export function isDashboardEvent(event: Events.IEvents | DashboardEvent): event is DashboardEvent {
  return typeof (event as DashboardEvent).session_type !== "undefined";
}

export function isFullSessionWithWorkout(
  session: Events.SessionResponse
): session is Events.SessionFull {
  return typeof (session as Events.SessionFull).workout === "object";
}
